/*
 *
 * Spaces constants
 *
 */

export const SLICE_NAME = 'spaces';
